import React from "react";

const PageSkeleton: React.FC = () => (
  <div className="animate-pulse space-y-4">
    <div className="h-8 w-56 rounded-xl bg-black/5" />
    <div className="h-20 rounded-2xl bg-black/5" />
    <div className="h-24 rounded-2xl bg-black/5" />
    <div className="h-24 rounded-2xl bg-black/5" />
  </div>
);

export default PageSkeleton;
export { PageSkeleton };
